import { render, staticRenderFns } from "./customBox.vue?vue&type=template&id=bbe9e72a&scoped=true&"
import script from "./customBox.vue?vue&type=script&lang=js&"
export * from "./customBox.vue?vue&type=script&lang=js&"
import style0 from "./customBox.vue?vue&type=style&index=0&id=bbe9e72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe9e72a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe9e72a')) {
      api.createRecord('bbe9e72a', component.options)
    } else {
      api.reload('bbe9e72a', component.options)
    }
    module.hot.accept("./customBox.vue?vue&type=template&id=bbe9e72a&scoped=true&", function () {
      api.rerender('bbe9e72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBox.vue"
export default component.exports